import { useQuery } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const fetchPendingTransactions = async ({
  start_date,
  end_date,
  page_size,
  page,
  last_evaluated_key,
}) => {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const payload = {
    page_size,
    page,
    start_date,
    end_date,
    last_evaluated_key,
  };

  if (page === 1) {
    payload.last_evaluated_key = null;
  }

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.GET_PENDING_TRANSACTIONS,
    payload
  );

  return (
    response?.data?.data ?? {
      transactions: [],
      pagination: { page, page_size, total_results: 0 },
    }
  );
};

export const useGetPendingTransactions = (
  start_date,
  end_date,
  page_size,
  page,
  last_evaluated_key
) => {
  return useQuery({
    queryKey: [
      'GET_PENDING_TRANSACTIONS',
      start_date,
      end_date,
      page_size,
      page,
    ],
    queryFn: () =>
      fetchPendingTransactions({
        start_date,
        end_date,
        page_size,
        page,
        last_evaluated_key,
      }),
    keepPreviousData: true,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
